import { setClickThroughSourceToLocalStorage } from '@realestate.com.au/iglu-data';
import type { ClickThroughSourceLocalStorageValue } from './TrackingSource';

export const clickThroughSourceTracking = (
  clickThroughSource?: ClickThroughSourceLocalStorageValue | null,
): void => {
  if (clickThroughSource) {
    setClickThroughSourceToLocalStorage({
      clickThroughTargetPathname: clickThroughSource.pathname,
      clickThroughSourcePage: clickThroughSource.page,
      clickThroughSourceElement: clickThroughSource.element,
      clickThroughSourceType: clickThroughSource.sourceType,
    });
  }
};
